// @flow
import React, { FC, useEffect, useState } from 'react';

import api from '@api';
import FileDisplay from 'src/components/FileDisplay';

export interface PDFformPropsType {
    idReturn?: string;
    close: () => void;
}

const PDFform: FC<PDFformPropsType> = (props) => {
    const [fileUrl, setFileUrl] = useState('');

    const loadFileData: any = () => {
        const url = `api/secure/returns/pdf-form/${props.idReturn}`;
        api('get', url).then((response: any) => {
            setFileUrl(`data:application/pdf;base64, ${response.data.data.content}`);
        });
    };

    useEffect(() => {
        if (!fileUrl) {
            loadFileData();
        }
    }, [fileUrl]);

    useEffect((): any => {
        return () => {
            if (fileUrl) {
                const wurl = window.URL || window.webkitURL;
                wurl.revokeObjectURL(fileUrl);
            }
        };
    }, [props.idReturn]);

    if (fileUrl) {
        return <FileDisplay file={{ data: fileUrl }} onClose={() => props.close()} style={{ width: '100%' }} />;
    }

    return null;
};

export default PDFform;
